<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Rep Details</th>
          <th>Member Email</th>
          <th>Date</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            v-if="!quoteList.records || quoteList.records.length == 0"
            colspan="5"
            align="center"
          >
            No records found.
          </td>
        </tr>
        <tr v-for="(record, index) in quoteList.records" :key="index">
          <td>
            <strong>{{ record.agent_info.rep_full_name }}</strong>
            <br />
            {{ record.agent_info.agent_code }}
            <br />
            {{ record.agent_info.agent_email }}
          </td>
          <td>{{ record.member_email }}
            <br />
              <strong>Verification Code : </strong> {{record.code}}
          </td>
          <td>
            <strong>Quote Sent Date:</strong>
            <br />
            {{ record.sent_date }}
            <br />
            <strong>Quote Sent Time:</strong>
            <br />
            {{ record.sent_time }}
          </td>
          <td>
            <span
              class="text-capitalize"
              :class="getClassName(record.status)"
              >{{ record.status.toLowerCase() }}</span
            >
          </td>
          <td class="ps-0">
            <div class="action-icons">
              <a
                href="javascript:void(0);"
                v-b-tooltip.hover
                v-if="!(record.new_quote)"
                title="View Details"
                @click="getQuoteDetails(record.id)"
                class=""
              >
                <i class="fas fa-info" aria-hidden="true"></i>
              </a>
              <a
              v-if="record.status != 'COMPLETED' && !record.quote_declined"
              href="javascript:void(0)"
              v-b-tooltip.hover
              title="Resend Quotes"
              @click="openResendQuoteModal(record.id, 'resend-quote-modal')"
            >

                <i class="fas fa-paper-plane" aria-hidden="true"></i>
              </a>
              <a
                href="javascript:void(0)"
                :class="[record.quote_seen ? 'quotes-viewed' : 'quotes-unseen']"
                v-b-tooltip.hover
                :title="record.quote_seen ? 'Quotes Viewed' : 'Quotes Unseen'"
              >
                <i class="far fa-eye"></i>
              </a>
              <a
                href="javascript:void(0);"
                v-b-tooltip.hover
                title="Delete Quote"
                class="icon-delete-bg"
                v-b-modal.quoteDeleteModal
                @click="selected_quote_id = record.id"
              >
                <i class="fas fa-trash" aria-hidden="true"></i>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <view-quote-modal :quoteDetails="quoteDetails" />
    <resend-quote-modal :rowId="rowId" />
    <quote-delete-modal  @deleteQuote="confirmDelete()" @closeDeleteModal="clearSelectedQuote()"/>
  </div>
</template>
<script>
import ViewQuoteModal from "../modal/ViewQuoteModal.vue";
import ResendQuoteModal from "../modal/ResendQuoteModal.vue";
import Api from "@/resource/Api";
import QuoteDeleteModal from "../modal/QuoteDeleteModal.vue";
export default {
  name: "QuoteList",
  components: {
    ViewQuoteModal,
    ResendQuoteModal,
    QuoteDeleteModal
  },
  props: {
    quoteList: {
      required: false,
      default: [],
    },
  },
  data() {
    return {
      quoteDetails: "",
      rowId: "",
      selected_quote_id: "",
    };
  },

  methods: {
    getClassName(status) {
      if (status == "NOT STARTED") {
        return "not-started";
      }
      return status.toLowerCase();
    },
    async getQuoteDetails(id) {
      let url = `v2/quote/details?id=${id}`;
      let loader = this.$loading.show();
      await Api.get(url)
        .then((res) => {
          this.quoteDetails = res.data.data;
          this.$bvModal.show("view-quote-modal");
        })
        .catch(() => {
          this.quoteDetails = "";
          this.$notify("Error! Unable To Load Details", "error");
        })
        .finally(() => {
          loader.hide();
        });
    },
    openResendQuoteModal(id, modalId) {
      this.rowId = id;
      this.$bvModal.show(modalId);
    },
    confirmDelete(){
      console.log("Deleting", this.selected_quote_id);
      let url = `v2/quote/soft-delete`;
      let loader = this.$loading.show();
      Api.delete(url, {quote_id: this.selected_quote_id})
        .then(() => {
          this.$notify("Quote Deleted Successfully", "success");
          this.clearSelectedQuote();
          this.$emit('reloadQuotes');
        })
        .catch(() => {
          this.$notify("Something went wrong. Please try again", "error");
        })
        .finally(() => {
          loader.hide();
        });
    },
    clearSelectedQuote() {
      this.selected_quote_id = "";
    }
  },
};
</script>

<style scoped>
.quotes-unseen {
  background: transparent linear-gradient(180deg, #0cf, #1597b8 49%, #0567bc);
}
.icon-delete-bg,
.icon-delete-bg:hover {
  background: #dc3545 !important;
  color: #fff !important;
}
</style>
